(function () {
  'use strict';

  class SqftCalculator {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.productSqft = parseFloat(container.dataset.productSqft) || 0;
      this.currencySymbol = container.dataset.currencySymbol || '$';

      // Load variant data map from embedded JSON
      try {
        const raw = document.getElementById('SqftVariantData-' + this.sectionId);
        this.variantData = raw ? JSON.parse(raw.textContent) : {};
      } catch (e) {
        this.variantData = {};
      }

      // DOM refs
      this.inputEl        = document.getElementById('SqftInput-' + this.sectionId);
      this.wasteEl        = document.getElementById('SqftWaste-' + this.sectionId);
      this.resultEl       = document.getElementById('SqftResult-' + this.sectionId);
      this.boxesNeededEl  = document.getElementById('SqftBoxesNeeded-' + this.sectionId);
      this.sqftPerBoxEl   = document.getElementById('SqftPerBox-' + this.sectionId);
      this.pricePerSqftEl = document.getElementById('SqftPricePerSqft-' + this.sectionId);
      this.resultBoxesEl  = document.getElementById('SqftResultBoxes-' + this.sectionId);
      this.resultDetailEl = document.getElementById('SqftResultDetail-' + this.sectionId);
      this.resultTotalEl  = document.getElementById('SqftResultTotal-' + this.sectionId);

      // The product info wrapper
      this.infoWrapper = this.container.closest('.product__info-wrapper');

      // Inject hidden line item property inputs into the form
      this.ensureLineItemProperties();

      // Set initial active variant
      this.activeVariantId = this.getInitialVariantId();

      this.updateStats();

      // Input events
      this.inputEl.addEventListener('input', () => this.calculate());
      this.wasteEl.addEventListener('change', () => this.calculate());

   document.addEventListener('variant:changed', (e) => {


  // Hyper doesn't reliably pass variant in detail
  // Read the current variant ID directly from the hidden form input instead
  const hiddenInput = document.querySelector(
    '#product-form-' + this.sectionId + ' .product-variant-id'
  );
  const variantIdStr = hiddenInput ? String(hiddenInput.value) : null;


  if (!variantIdStr || !this.variantData[variantIdStr]) return;

  this.activeVariantId = variantIdStr;

  this.quantityInput = document.querySelector(
    '#product-form-' + this.sectionId + ' .quantity__input'
  );

  this.updateStats();
  if (this.inputEl.value) this.calculate();
});
    }

    // ─── Helpers ────────────────────────────────────────────────────────────────

    getInitialVariantId() {
      const hiddenInput = document.querySelector(
        '#product-form-' + this.sectionId + ' .product-variant-id'
      );
      if (hiddenInput && hiddenInput.value) return String(hiddenInput.value);
      return Object.keys(this.variantData)[0] || null;
    }

    getQuantityInput() {
      return document.querySelector(
        '#product-form-' + this.sectionId + ' .quantity__input'
      );
    }

    getActiveVariant() {
      return this.variantData[this.activeVariantId] || null;
    }

    getBoxCount(sqftNeeded, sqftPerBox) {
      if (!sqftPerBox || sqftPerBox <= 0) return 0;
      return Math.ceil(sqftNeeded / sqftPerBox);
    }

    formatPrice(cents) {
      return this.currencySymbol + (cents / 100).toFixed(2);
    }

    // ─── Stats panel ─────────────────────────────────────────────────────────────

    updateStats() {
      const v = this.getActiveVariant();
      if (!v) return;

      const sqft = v.sqft || this.productSqft;
      const pricePerSqft = sqft > 0 ? (v.price / 100) / sqft : 0;

      this.sqftPerBoxEl.textContent = sqft + ' sqft';
      this.pricePerSqftEl.textContent = this.currencySymbol + pricePerSqft.toFixed(2);

      if (this.inputEl.value && parseFloat(this.inputEl.value) > 0) {
        const waste = this.wasteEl.checked;
        const adjusted = parseFloat(this.inputEl.value) * (waste ? 1.1 : 1);
        this.boxesNeededEl.textContent = this.getBoxCount(adjusted, sqft);
      } else {
        this.boxesNeededEl.textContent = '—';
      }
    }

    // ─── Main calculation ─────────────────────────────────────────────────────────

    calculate() {
      const raw = parseFloat(this.inputEl.value);
      const v = this.getActiveVariant();

      if (!raw || raw <= 0 || !v) {
        this.reset();
        return;
      }

      const sqftPerBox = v.sqft || this.productSqft;
      if (!sqftPerBox || sqftPerBox <= 0) {
        this.reset();
        return;
      }

      const waste = this.wasteEl.checked;
      const adjustedSqft = waste ? raw * 1.1 : raw;
      const boxes = this.getBoxCount(adjustedSqft, sqftPerBox);
      const covers = (boxes * sqftPerBox).toFixed(2);
      const extra = (parseFloat(covers) - raw).toFixed(1);
      const totalCents = v.price * boxes;

      this.boxesNeededEl.textContent = boxes;

      this.resultBoxesEl.textContent = "You'll need " + boxes + ' box' + (boxes !== 1 ? 'es' : '');
      this.resultDetailEl.textContent =
        'Covers ' + covers + ' sqft · ' + extra + ' sqft extra' +
        (waste ? ' (incl. 10% waste)' : '');
      this.resultTotalEl.textContent = this.formatPrice(totalCents);
      this.resultEl.removeAttribute('hidden');

      const qtyInput = this.getQuantityInput();
      if (qtyInput) {
        qtyInput.value = boxes;
        qtyInput.removeAttribute('min');
        qtyInput.removeAttribute('max');
        qtyInput.removeAttribute('data-min');
        qtyInput.removeAttribute('data-max');
      }

      if (this.infoWrapper) {
        this.infoWrapper.classList.add('sqft-calculator-active');
      }

      this.setLineItemProperties(raw, boxes, waste);
    }

    // ─── Reset state ──────────────────────────────────────────────────────────────

    reset() {
      this.resultEl.setAttribute('hidden', '');
      this.boxesNeededEl.textContent = '—';

      const qtyInput = this.getQuantityInput();
      if (qtyInput) qtyInput.value = 1;

      if (this.infoWrapper) {
        this.infoWrapper.classList.remove('sqft-calculator-active');
      }

      this.clearLineItemProperties();
    }

    // ─── Line item properties ─────────────────────────────────────────────────────

    ensureLineItemProperties() {
      const form = document.getElementById('product-form-' + this.sectionId);
      if (!form) return;

      ['Area (sqft)', 'Boxes'].forEach(name => {
        const selector = 'input[name="properties[' + name + ']"]';
        if (!form.querySelector(selector)) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + name + ']';
          input.value = '';
          form.appendChild(input);
        }
      });
    }

    setLineItemProperties(sqft, boxes, waste) {
      const form = document.getElementById('product-form-' + this.sectionId);
      if (!form) return;

      const areaInput = form.querySelector('input[name="properties[Area (sqft)]"]');
      const boxInput  = form.querySelector('input[name="properties[Boxes]"]');

      if (areaInput) areaInput.value = sqft + ' sqft' + (waste ? ' (+10% waste buffer)' : '');
      if (boxInput)  boxInput.value  = boxes + ' box' + (boxes !== 1 ? 'es' : '');
    }

    clearLineItemProperties() {
      const form = document.getElementById('product-form-' + this.sectionId);
      if (!form) return;

      const areaInput = form.querySelector('input[name="properties[Area (sqft)]"]');
      const boxInput  = form.querySelector('input[name="properties[Boxes]"]');

      if (areaInput) areaInput.value = '';
      if (boxInput)  boxInput.value  = '';
    }
  }

  // ─── Init ─────────────────────────────────────────────────────────────────────

  function initCalculators() {
    document.querySelectorAll('.sqft-calculator').forEach(el => {
      if (!el.dataset.sqftInit) {
        el.dataset.sqftInit = 'true';
        new SqftCalculator(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalculators);
  } else {
    initCalculators();
  }

})();